import { render } from "./auth_manage.vue?vue&type=template&id=1e2ebc68&scoped=true"
import script from "./auth_manage.vue?vue&type=script&lang=js"
export * from "./auth_manage.vue?vue&type=script&lang=js"

import "./auth_manage.vue?vue&type=style&index=0&id=1e2ebc68&scoped=true&lang=css"

import exportComponent from "E:\\daxiang\\code\\dx_project_vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e2ebc68"]])

export default __exports__